import { CircularProgress, Stack, Typography } from '@mui/material';
import { colors } from '~/theme';

export const LoadingScreen = () => {
  return (
    <Stack alignItems="center" justifyContent="center" minHeight="60vh" spacing={4} px={3} py={6} textAlign="center">
      <CircularProgress size={56} />
      <Typography variant="h1" fontWeight={700} sx={{ fontSize: '22px', color: colors.charcoal }}>
        Conferindo os dados...
      </Typography>
    </Stack>
  );
};
